const extensions = {
  viewtitle: 'Extensions',
  extensionname: 'Extension',
  sites: 'Sites',
  site: 'Site',
  supportsupdater: 'Supports Updater',
  automaticupdates: 'Automatic Updates',
  supportupdaterpositive: 'Supports updater',
  supportupdaternegative: 'No support',
  searchterm: 'Extension name',
  enableautoupdate: 'Enable Autoupdate',
  disableautoupdate: 'Disable Autoupdate',
  extensiontype: 'Type',
  typefilter: 'Select a Type',
  updatesupportfilter: 'Filter Update Support',
  autoupdatefilter: 'Filter Autoupdate'
}

export default extensions
